/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cna_Add_NumberInputs */

const en_cna_add_number = /** @type {(inputs: Cna_Add_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add another number`)
};

const ja_cna_add_number = /** @type {(inputs: Cna_Add_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`番号を追加`)
};

const fr_cna_add_number = /** @type {(inputs: Cna_Add_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un autre numéro`)
};

const de_cna_add_number = /** @type {(inputs: Cna_Add_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Nummer hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add another number" |
*
* @param {Cna_Add_NumberInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cna_add_number = /** @type {((inputs?: Cna_Add_NumberInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cna_Add_NumberInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cna_add_number(inputs)
	if (locale === "ja") return ja_cna_add_number(inputs)
	if (locale === "fr") return fr_cna_add_number(inputs)
	return de_cna_add_number(inputs)
});